import type { Transition } from "motion/react";

export const springTransitions = {
  fast: { bounce: 0, duration: 0.15, type: "spring" },
  normal: { bounce: 0, duration: 0.3, type: "spring" },
  slower: { bounce: 0, duration: 0.6, type: "spring" },
} satisfies Record<string, Transition>;

// Each preset has `initial`, `animate` and `exit` keys, so it can be passed as
// `variants` or spread straight onto a motion element.

export const fadeVariants = {
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  initial: { opacity: 0 },
} as const;

export const blurVariants = {
  animate: { filter: "blur(0px)", opacity: 1 },
  exit: { filter: "blur(4px)", opacity: 0 },
  initial: { filter: "blur(4px)", opacity: 0 },
} as const;

/** Blurs and shrinks; for icons that swap in place. */
export const fadeBlurVariants = {
  animate: { filter: "blur(0px)", opacity: 1, scale: 1 },
  exit: { filter: "blur(4px)", opacity: 0, scale: 0.5 },
  initial: { filter: "blur(4px)", opacity: 0, scale: 0.5 },
} as const;

/** Drops in from above and leaves downwards. */
export const slideVariants = (distance: number) =>
  ({
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: distance },
    initial: { opacity: 0, y: -distance },
  }) as const;

/** `slideVariants(24)` with a blur; for panels that replace each other. */
export const slideBlurVariants = {
  animate: { filter: "blur(0px)", opacity: 1, y: 0 },
  exit: { filter: "blur(4px)", opacity: 0, y: 24 },
  initial: { filter: "blur(4px)", opacity: 0, y: -24 },
} as const;
